import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import FunnelFilter, { FUNNEL_FILTER_OPERATORS } from "@app/util/filters/FunnelFilter";

import Field, { FieldProperties } from "./Field";

class FunnelField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "funnel",
        filterInstances: {
          funnel: FunnelFilter,
        },
        operators: FUNNEL_FILTER_OPERATORS,
      },
      features: [
        FieldFeature.VISIBLE_BY_DEFAULT,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.BULK_EDIT,
        FieldFeature.FUNNEL_FIELD,
        FieldFeature.DATA_VIEW,
        FieldFeature.HISTORY_FIELD,
        FieldFeature.REQUIRED,
      ],
      filterType: FieldType.ID,
      formProperties: {
        fullWidth: true,
      },
      importProperties: { required: true },
      platformFilterNames: ["funnelId", "funnel.id"],
      type: FieldType.STRING,
      valueGetter: ["funnel", "name"],
      ...data,
    });
  }
}

export default FunnelField;
